import request from '@/api/axios';

// export const test2 = (current, size, params) => {
//   return request({
//     url: '/ding-ding/dd-user/test2',
//     method: 'get',
//     params: {
//       ...params,
//       current,
//       size,
//     }
//   })
// }

// export const test1 = (row) => {
//   return request({
//     url: '/ding-ding/dd-user/test1',
//     method: 'post',
//     data: row
//   })
// }

export const getWorkInfo = (params) => {
  return request({
    url: '/ding-ding/dd-user/work-info',
    method: 'get',
    params: {
      ...params,
    }
  })
}

export const getDayWorkInfo = (params) => {
  return request({
    url: '/ding-ding/dd-user/day-work-info',
    method: 'get',
    params: {
      ...params,
    }
  })
}

export const addHourUser = (row) => {
  return request({
    url: '/ding-ding/dd-user/add-hour-user',
    method: 'post',
    data: row
  })
}

export const delHourUser = (params) => {
  return request({
    url: '/ding-ding/dd-user/del-hour-user',
    method: 'get',
    params: {
      ...params,
    }
  })
}

export const userLogin = (params) => {
  return request({
    url: '/ding-ding/dd-user/auth/token',
    method: 'get',
    params: {
      ...params,
    }
  })
}

 
 
